let config={
    appName:'StoryRover',
    appStoreUrl:'https://apps.apple.com/us/app/id1538306973',
    contactEmail:'storyrover.cs@outlook.com',
    copyright:'StoryRover',
    title:'THISFUN',
    logoName:'StoryRover',
    fbid:'1124673794769586',
    websiteUrl:'storyrover.icrazynovel.com'
}

export default config;
